const mime = require('mime-types');

export default class htmlUtils {
    /**
     * Create a download link and show a UI to download it
     */
    static createDownloadAction(datas, type, filename = 'datas', needExtension = true) {
        if (!datas || !type) {
            console.error('Missing infos', { datas, filename, type });
            return;
        }

        let file = datas;
        if (!(datas instanceof Blob)) {
            file = new Blob([datas], { type });
        }
        const anchor = document.createElement('a');
        anchor.download = needExtension ? `${filename}.${mime.extension(type)}` : filename;
        anchor.href = (window.webkitURL || window.URL).createObjectURL(file);
        anchor.dataset.downloadurl = [type, anchor.download, anchor.href].join(':');
        anchor.click();
        URL.revokeObjectURL(anchor.href);
    }

    /**
     * Put a text in the clipboard, returns whether it worked.
     * Falls back on a temporary selection when the async Clipboard API is not
     * available: it needs a secure context, so it is missing when the BO is
     * served over plain http.
     */
    static async copyToClipboard(text: string): Promise<boolean> {
        if (!text) {
            return false;
        }

        try {
            if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(text);
                return true;
            }
        } catch (e) {
            // Permission refused or insecure context, try the fallback below
        }

        try {
            const textarea = document.createElement('textarea');
            textarea.value = text;
            textarea.setAttribute('readonly', '');
            // Keep it out of sight and avoid scrolling the page on focus
            textarea.style.position = 'fixed';
            textarea.style.top = '0';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            const copied = document.execCommand('copy');
            document.body.removeChild(textarea);
            return copied;
        } catch (e) {
            console.error('Unable to copy to clipboard', e);
            return false;
        }
    }
}

export function clsx(...classes: Array<string | undefined | null | boolean | { [key: string]: boolean }>): string {
    return classes
        .flatMap((cls) => {
            if (typeof cls === 'string') {
                return cls;
            }
            if (typeof cls === 'object' && cls !== null) {
                return Object.entries(cls)
                    .filter(([, value]) => value)
                    .map(([key]) => key);
            }
            return [];
        })
        .filter(Boolean)
        .join(' ');
}
